import { render, staticRenderFns } from "./Memorama.vue?vue&type=template&id=17f69442&scoped=true&"
import script from "./Memorama.vue?vue&type=script&lang=js&"
export * from "./Memorama.vue?vue&type=script&lang=js&"
import style0 from "./Memorama.vue?vue&type=style&index=0&id=17f69442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f69442",
  null
  
)

export default component.exports